import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { DisplayDecorator } from '../decorators/display-decorator';
import { MeasurementToolsDetailsModel } from '../models/low-level/measurement-tools-details.model';
import { TextModel } from '../models/primitive/text.model';

/**
 * Public contract of the measurement-tools service. Implemented by both
 * `MeasurementToolsService` and the NgRx-backed `MeasurementToolsNgrxService`;
 * consumers depend on this interface via {@link MeasurementToolsInstanceToken}.
 */
export interface MeasurementToolsInterface {
    init(): Observable<MeasurementToolsDetailsModel[]>;
    getMeasurementToolsDetailsList(): MeasurementToolsDetailsModel[];
    getOriginalDropdownEntries(): Array<DisplayDecorator<TextModel>>;
    setDropdownEntries(entries: Array<DisplayDecorator<TextModel>>): void;
    sortByGid(entries: Array<DisplayDecorator<TextModel>>): Array<DisplayDecorator<TextModel>>;
}

export const MeasurementToolsInstanceToken = new InjectionToken<MeasurementToolsInterface>('MeasurementToolsInterface');
